import { Directive, ElementRef, HostListener, Renderer2, OnDestroy, NgModule } from '@angular/core';
import { UsuarioServiceProvider } from '../service/index.providers';

@Directive({
  selector: '[appImageZoom]'
})

export class ImageZoomDirective implements OnDestroy {

  private modalOverlay: HTMLElement | null = null;
  private imgElement: HTMLElement | null = null;
  private scale = 1;
  private minScale = 1;
  private maxScale = 4;
  private lastDistance = 0;
  private isPanning = false;
  private startX = 0;
  private startY = 0;
  private translateX = 0;
  private translateY = 0;
  private primaryColor: string | null = "#5458e9";
  brandConfig;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private up: UsuarioServiceProvider,
  ) {
    this.up.configBrand.subscribe((res) => {
			//console.log("data empresa en IMAGEN SVG::", res);
			this.brandConfig = res;

			if (this.brandConfig) {
				this.primaryColor = this.brandConfig.color_primario_app;
			}
		});

  }

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    const target = event.target as HTMLElement;

    if (target.tagName === 'IMG') {
      event.preventDefault();
      event.stopPropagation();

      // Simula el click en el radio
      const ionRadio = this.findParentIonRadio(target);
      if (ionRadio) {
        ionRadio.click();
      };

      const imgSrc = (target as HTMLImageElement).src;
      if (imgSrc) {
        this.openImageModal(imgSrc);
      }
    }
  }

  private findParentIonRadio(element: HTMLElement): HTMLElement | null {
  let current = element.parentElement;
  while (current) {
    if (current.tagName === 'ION-RADIO') {
      return current;
    }
    current = current.parentElement;
  }
  return null;
}

  private openImageModal(imageSrc: string): void {
    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;

    // Create modal overlay
    this.modalOverlay = this.renderer.createElement('div');
    this.renderer.setStyle(this.modalOverlay, 'position', 'fixed');
    this.renderer.setStyle(this.modalOverlay, 'top', '0');
    this.renderer.setStyle(this.modalOverlay, 'left', '0');
    this.renderer.setStyle(this.modalOverlay, 'width', '100%');
    this.renderer.setStyle(this.modalOverlay, 'height', '100%');
    this.renderer.setStyle(this.modalOverlay, 'background-color', 'rgba(0, 0, 0, 0.9)');
    this.renderer.setStyle(this.modalOverlay, 'display', 'flex');
    this.renderer.setStyle(this.modalOverlay, 'justify-content', 'center');
    this.renderer.setStyle(this.modalOverlay, 'align-items', 'center');
    this.renderer.setStyle(this.modalOverlay, 'z-index', '9999999');
    this.renderer.setStyle(this.modalOverlay, 'overflow', 'hidden');
    this.renderer.setStyle(this.modalOverlay, 'touch-action', 'none');

    // Create image container
    const imgContainer = this.renderer.createElement('div');
    this.renderer.setStyle(imgContainer, 'position', 'relative');
    this.renderer.setStyle(imgContainer, 'width', '100%');
    // this.renderer.setStyle(imgContainer, 'height', '100%');
    this.renderer.setStyle(imgContainer, 'height', 'calc(100% - 40px)');
    this.renderer.setStyle(imgContainer, 'margin-top', '40px');
    this.renderer.setStyle(imgContainer, 'display', 'flex');
    this.renderer.setStyle(imgContainer, 'justify-content', 'center');
    this.renderer.setStyle(imgContainer, 'align-items', 'center');

    // Create image element
    this.imgElement = this.renderer.createElement('img');
    this.renderer.setAttribute(this.imgElement, 'src', imageSrc);
    this.renderer.setStyle(this.imgElement, 'max-width', '90%');
    this.renderer.setStyle(this.imgElement, 'max-height', '90%');
    this.renderer.setStyle(this.imgElement, 'object-fit', 'contain');
    this.renderer.setStyle(this.imgElement, 'box-shadow', '0 0 20px rgba(0, 0, 0, 0.5)');
    this.renderer.setStyle(this.imgElement, 'cursor', 'grab');
    this.renderer.setStyle(this.imgElement, 'transition', 'transform 0.1s ease-out');
    this.renderer.setStyle(this.imgElement, 'user-select', 'none');





    // Create zoom controls
    const zoomControls = this.createZoomControls();


    // Append elements
    this.renderer.appendChild(imgContainer, this.imgElement);
    this.renderer.appendChild(this.modalOverlay, imgContainer);
    this.renderer.appendChild(this.modalOverlay, zoomControls);
    this.renderer.appendChild(document.body, this.modalOverlay);

    // // Event listeners
    // this.setupEventListeners(closeBtn);

    // Prevent body scroll
    this.renderer.setStyle(document.body, 'overflow', 'hidden');
  }

  private createZoomControls(): HTMLElement {
    // const controls = this.renderer.createElement('div');
    // this.renderer.setStyle(controls, 'position', 'absolute');
    // this.renderer.setStyle(controls, 'top', '4px');
    // this.renderer.setStyle(controls, 'right', '8px');

    // this.renderer.setStyle(controls, 'display', 'flex');
    // this.renderer.setStyle(controls, 'gap', '10px');
    // this.renderer.setStyle(controls, 'z-index', '10000');

     // Create toolbar container
    const controls = this.renderer.createElement('div');
    // const toolbarContainer = this.renderer.createElement('div');
    this.renderer.setStyle(controls, 'position', 'absolute');
    this.renderer.setStyle(controls, 'top', '0px');
    this.renderer.setStyle(controls, 'left', '0px');
    this.renderer.setStyle(controls, 'right', '0px');
    this.renderer.setStyle(controls, 'width', '100%');
    this.renderer.setStyle(controls, 'height', '40px');
    this.renderer.setStyle(controls, 'display', 'flex');
    this.renderer.setStyle(controls, 'justify-content', 'end');
    this.renderer.setStyle(controls, 'align-items', 'center');
    this.renderer.setStyle(controls, 'gap', '10px');
    this.renderer.setStyle(controls, 'padding-right', '8px');
    this.renderer.setStyle(controls, 'background', this.primaryColor);

    // Create close button
    const closeBtn = this.renderer.createElement('button');
    const closeBtnText = this.renderer.createText('×');
    this.renderer.appendChild(closeBtn, closeBtnText);
    // this.renderer.setStyle(closeBtn, 'position', 'absolute');
    // this.renderer.setStyle(closeBtn, 'top', '4px');
    // this.renderer.setStyle(closeBtn, 'right', '8px');
    this.renderer.setStyle(closeBtn, 'background', 'rgba(255, 255, 255, 0)');
    this.renderer.setStyle(closeBtn, 'border', 'none');
    this.renderer.setStyle(closeBtn, 'color', 'white');
    this.renderer.setStyle(closeBtn, 'font-size', '20px');
    this.renderer.setStyle(closeBtn, 'font-weight', '600');
    this.renderer.setStyle(closeBtn, 'cursor', 'pointer');
    this.renderer.setStyle(closeBtn, 'width', '30px');
    this.renderer.setStyle(closeBtn, 'height', '30px');
    this.renderer.setStyle(closeBtn, 'border-radius', '8px');
    this.renderer.setStyle(closeBtn, 'display', 'flex');
    this.renderer.setStyle(closeBtn, 'align-items', 'center');
    this.renderer.setStyle(closeBtn, 'justify-content', 'center');
    this.renderer.setStyle(closeBtn, 'transition', 'background 0.3s');
    // this.renderer.setStyle(closeBtn, 'z-index', '10000');

     // Close button hover
    this.renderer.listen(closeBtn, 'mouseenter', () => {
      this.renderer.setStyle(closeBtn, 'background', 'rgba(255, 255, 255, 0.4)');
    });
    this.renderer.listen(closeBtn, 'mouseleave', () => {
      this.renderer.setStyle(closeBtn, 'background', 'rgba(255, 255, 255, 0)');
    });

    this.setupEventListeners(closeBtn);


    // Zoom out button
    const zoomOutBtn = this.renderer.createElement('button');
    const zoomOutText = this.renderer.createText('−');
    this.renderer.appendChild(zoomOutBtn, zoomOutText);
    this.styleZoomButton(zoomOutBtn);
    this.renderer.listen(zoomOutBtn, 'click', (e: Event) => {
      e.stopPropagation();
      this.zoomOut();
    });

    // Reset button
    const resetBtn = this.renderer.createElement('button');
    const resetText = this.renderer.createText('⟲');
    this.renderer.appendChild(resetBtn, resetText);
    this.styleResetButton(resetBtn);
    this.renderer.listen(resetBtn, 'click', (e: Event) => {
      e.stopPropagation();
      this.resetZoom();
    });

    // Zoom in button
    const zoomInBtn = this.renderer.createElement('button');
    const zoomInText = this.renderer.createText('+');
    this.renderer.appendChild(zoomInBtn, zoomInText);
    this.styleZoomButton(zoomInBtn);
    this.renderer.listen(zoomInBtn, 'click', (e: Event) => {
      e.stopPropagation();
      this.zoomIn();
    });

    this.renderer.appendChild(controls, zoomOutBtn);
    this.renderer.appendChild(controls, zoomInBtn);
    this.renderer.appendChild(controls, resetBtn);
    this.renderer.appendChild(controls, closeBtn);


    return controls;
  }

  private styleZoomButton(button: HTMLElement): void {
    // this.renderer.setStyle(button, 'position', 'absolute');
    // this.renderer.setStyle(button, 'top', '4px');
    // this.renderer.setStyle(button, 'right', '8px');
    this.renderer.setStyle(button, 'background', 'rgba(255, 255, 255, 0)');
    this.renderer.setStyle(button, 'border', 'none');
    this.renderer.setStyle(button, 'color', 'white');
    this.renderer.setStyle(button, 'font-size', '20px');
    this.renderer.setStyle(button, 'font-weight', '600');
    this.renderer.setStyle(button, 'cursor', 'pointer');
    this.renderer.setStyle(button, 'width', '30px');
    this.renderer.setStyle(button, 'height', '30px');
    this.renderer.setStyle(button, 'border-radius', '8px');
    this.renderer.setStyle(button, 'display', 'flex');
    this.renderer.setStyle(button, 'align-items', 'center');
    this.renderer.setStyle(button, 'justify-content', 'center');
    this.renderer.setStyle(button, 'transition', 'background 0.3s');
    // this.renderer.setStyle(button, 'z-index', '10000');

    this.renderer.listen(button, 'mouseenter', () => {
      this.renderer.setStyle(button, 'background', 'rgba(255, 255, 255, 0.4)');
    });
    this.renderer.listen(button, 'mouseleave', () => {
      this.renderer.setStyle(button, 'background', 'rgba(255, 255, 255, 0)');
    });
  }
  private styleResetButton(button: HTMLElement): void {
    this.renderer.setStyle(button, 'background', 'rgba(255, 255, 255, 0)');
    this.renderer.setStyle(button, 'border', 'none');
    this.renderer.setStyle(button, 'color', 'white');
    this.renderer.setStyle(button, 'font-size', '15px');
    this.renderer.setStyle(button, 'font-weight', '400');
    this.renderer.setStyle(button, 'cursor', 'pointer');
    this.renderer.setStyle(button, 'width', '30px');
    this.renderer.setStyle(button, 'height', '30px');
    this.renderer.setStyle(button, 'border-radius', '8px');
    this.renderer.setStyle(button, 'display', 'flex');
    this.renderer.setStyle(button, 'align-items', 'center');
    this.renderer.setStyle(button, 'justify-content', 'center');
    this.renderer.setStyle(button, 'transition', 'background 0.3s');
    // this.renderer.setStyle(button, 'z-index', '10000');

    this.renderer.listen(button, 'mouseenter', () => {
      this.renderer.setStyle(button, 'background', 'rgba(255, 255, 255, 0.4)');
    });
    this.renderer.listen(button, 'mouseleave', () => {
      this.renderer.setStyle(button, 'background', 'rgba(255, 255, 255, 0)');
    });
  }

  private setupEventListeners(closeBtn: HTMLElement): void {
    // Close on overlay click
    this.renderer.listen(this.modalOverlay, 'click', (e: Event) => {
      if (e.target === this.modalOverlay && this.scale === 1) {
        this.closeModal();
      }
    });

    // Close button click
    this.renderer.listen(closeBtn, 'click', (e: Event) => {
      e.stopPropagation();
      this.closeModal();
    });

    // ESC key
    this.renderer.listen(document, 'keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        this.closeModal();
      }
    });

    // Mouse wheel zoom
    this.renderer.listen(this.imgElement, 'wheel', (e: WheelEvent) => {
      e.preventDefault();
      const delta = e.deltaY > 0 ? -0.1 : 0.1;
      this.applyZoom(delta);
    });

    // Double click to zoom
    this.renderer.listen(this.imgElement, 'dblclick', (e: MouseEvent) => {
      e.preventDefault();
      if (this.scale === 1) {
        this.scale = 2;
      } else {
        this.resetZoom();
      }
      this.updateTransform();
    });

    // Touch events for pinch zoom
    this.renderer.listen(this.imgElement, 'touchstart', (e: TouchEvent) => {
      if (e.touches.length === 2) {
        this.lastDistance = this.getDistance(e.touches[0], e.touches[1]);
      } else if (e.touches.length === 1 && this.scale > 1) {
        this.isPanning = true;
        this.startX = e.touches[0].clientX - this.translateX;
        this.startY = e.touches[0].clientY - this.translateY;
        this.renderer.setStyle(this.imgElement, 'cursor', 'grabbing');
      }
    });

    this.renderer.listen(this.imgElement, 'touchmove', (e: TouchEvent) => {
      e.preventDefault();
      if (e.touches.length === 2) {
        const distance = this.getDistance(e.touches[0], e.touches[1]);
        const delta = (distance - this.lastDistance) * 0.01;
        this.applyZoom(delta);
        this.lastDistance = distance;
      } else if (e.touches.length === 1 && this.isPanning) {
        this.translateX = e.touches[0].clientX - this.startX;
        this.translateY = e.touches[0].clientY - this.startY;
        this.updateTransform();
      }
    });

    this.renderer.listen(this.imgElement, 'touchend', () => {
      this.isPanning = false;
      this.renderer.setStyle(this.imgElement, 'cursor', 'grab');
    });

    // Mouse drag for panning
    this.renderer.listen(this.imgElement, 'mousedown', (e: MouseEvent) => {
      if (this.scale > 1) {
        this.isPanning = true;
        this.startX = e.clientX - this.translateX;
        this.startY = e.clientY - this.translateY;
        this.renderer.setStyle(this.imgElement, 'cursor', 'grabbing');
        e.preventDefault();
      }
    });

    this.renderer.listen(document, 'mousemove', (e: MouseEvent) => {
      if (this.isPanning) {
        this.translateX = e.clientX - this.startX;
        this.translateY = e.clientY - this.startY;
        this.updateTransform();
      }
    });

    this.renderer.listen(document, 'mouseup', () => {
      this.isPanning = false;
      if (this.imgElement) {
        this.renderer.setStyle(this.imgElement, 'cursor', 'grab');
      }
    });
  }

  private getDistance(touch1: Touch, touch2: Touch): number {
    const dx = touch1.clientX - touch2.clientX;
    const dy = touch1.clientY - touch2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  private applyZoom(delta: number): void {
    this.scale = Math.min(Math.max(this.scale + delta, this.minScale), this.maxScale);

    if (this.scale === 1) {
      this.translateX = 0;
      this.translateY = 0;
    }

    this.updateTransform();
  }

  private zoomIn(): void {
    this.applyZoom(0.3);
  }

  private zoomOut(): void {
    this.applyZoom(-0.3);
  }

  private resetZoom(): void {
    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;
    this.updateTransform();
  }

  private updateTransform(): void {
    if (this.imgElement) {
      const transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`;
      this.renderer.setStyle(this.imgElement, 'transform', transform);
    }
  }

  private closeModal(): void {
    if (this.modalOverlay) {
      this.renderer.removeChild(document.body, this.modalOverlay);
      this.modalOverlay = null;
      this.imgElement = null;
      this.renderer.removeStyle(document.body, 'overflow');
      this.scale = 1;
      this.translateX = 0;
      this.translateY = 0;
      this.isPanning = false;
    }
  }

  ngOnDestroy(): void {
    this.closeModal();
  }
}


@NgModule({
  declarations: [ ImageZoomDirective ],
  exports: [ ImageZoomDirective ]
})
export class  ImageZoomModule {}
